export const pageSize = 20;

export const deliveryProviderProjection = [
    "deliveryProviderId",
    "name",
    "phone",
    "contactName",
    "deliverySystem",
    "email"
];

export const DeliverySystem = {
    WellB: "wellb",
    Lionwheel: "lionwheel"
};
